import React, { useContext } from "react";
import "./Works.css";
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Amazon from "../../img/sandeep.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import {Link} from 'react-scroll'
const Works = () => {
  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  // transition
  return (
    <div className="works" id="works">
      {/* left side */}
      <div className="w-left">
        <div className="awesome">
          {/* dark Mode */}
          <span style={{ color: darkMode ? "white" : "" }}>
            Works for All these
          </span>
          <span>Software</span>
          <spane>
           Express GST Software
            <br />
           Express TDS Software
            <br />
           E-Commerce Application
            <br />
           IOT Project
          </spane>
          <Link to="contact" smooth={true} spy={true}>
            <button className="button s-button">Hire Me</button>
          </Link>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>

        {/* right side */}
      </div>
      <div className="w-right">
        <motion.div
          initial={{ rotate: 45 }}
          whileInView={{ rotate: 0 }}
          viewport={{ margin: "-40px" }}
          transition={{ duration: 3.5, type: "spring" }}
          className="w-mainCircle"
        >
          <div className="w-secCircle">
            {/* <img src={Upwork} alt="" /> */}
            KDK software
          </div>
          <div className="w-secCircle">
            {/* <img src={Fiverr} alt="" /> */}
            Navastha Infotech
          </div>
          <div className="w-secCircle">
            <img src={Amazon} alt="" />
            
          </div>{" "}
          <div className="w-secCircle">
            {/* <img src={Shopify} alt="" /> */}
            1 year Exp in Development field
          </div>
          <div className="w-secCircle">
            {/* <img src={Facebook} alt="" /> */}
            Study From GIT College
          </div>
        </motion.div>
        {/* background Circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
      </div>
    </div>
  );
};

export default Works;
